/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterTypeQueryVariables = Types.Exact<{
  matterTypeId: Types.Scalars["ID"]["input"];
}>;

export type GqlMatterTypeQuery = {
  __typename: "Query";
  matterType?: {
    __typename: "MatterType";
    id: string;
    source: string;
    name: string;
    category: string;
    location: string;
    representativeOptions: Array<string>;
  } | null;
};

export const MatterTypeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "matterType" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "matterTypeId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "matterType" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "matterTypeId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "matterTypeId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "matterTypeFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterTypeFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterType" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "representativeOptions" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlMatterTypeQuery, GqlMatterTypeQueryVariables>;
